// Display-only adaptation. The option value sent to the server is NEVER changed.
// The narrow fallback also supports generated templates copied before mapping
// metadata was introduced; ordinary answers containing numbers stay intact.
export function checklistOptionLabel(option, qualificationRule, representative) {
  if (!representative || typeof option !== 'string') return option;
  const mapped = qualificationRule?.option_labels?.[option];
  if (mapped) return mapped;
  const generated = option.match(/^\[[a-zA-Z0-9_-]+\]\s+(.+?)\s+·\s+-?\d+(?:[.,]\d+)?$/);
  return generated ? generated[1] : option;
}

export function checklistQuestionLabel(text, qualificationRule, representative) {
  if (!representative || typeof text !== 'string') return text;
  const prefix = qualificationRule?.criterion_code ? `[${qualificationRule.criterion_code}] ` : null;
  if (prefix && text.startsWith(prefix)) return text.slice(prefix.length);
  // Only generated internal hashes in copied templates, not standard clauses.
  return text.replace(/^\[r_[a-f0-9]{24}\]\s+/, '');
}
